import React from 'react';
import Helmet from 'react-helmet';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import SiteLayout from '../Shared/SiteLayout';
import ProductShowCard from './Components/ProductShowCard';

const ProductShow = () => {
     const { auth, app, data } = usePage().props;
     return (
          <React.Fragment>
               <Helmet>
                    <title>{data.product.name}</title>
               </Helmet>
               <section className="w-full pt-10 pb-10 bg-white">
                    <div className="w-full container mx-auto">
                         <ProductShowCard />
                    </div>
               </section>

               <section className="w-full pt-10 pb-10 bg-white">
                    <div className="w-full md:container mx-auto border-t border-gray-400"></div>
               </section>
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
ProductShow.layout = page => <SiteLayout children={page} header={'Catalog'} />;

export default ProductShow;
